var map = {
	"./template.bet575": 1522,
	"./template.bet575.tsx": 1522,
	"./template.bet777": 1524,
	"./template.bet777.tsx": 1524,
	"./template.betgalaxy": 1525,
	"./template.betgalaxy.tsx": 1525,
	"./template.betprofessor": 1526,
	"./template.betprofessor.tsx": 1526,
	"./template.betroyale": 1527,
	"./template.betroyale.tsx": 1527,
	"./template.betstride": 1528,
	"./template.betstride.tsx": 1528,
	"./template.buffalobet": 1529,
	"./template.buffalobet.tsx": 1529,
	"./template.chromabet": 1530,
	"./template.chromabet.tsx": 1530,
	"./template.default": 714,
	"./template.default.tsx": 714,
	"./template.epicodds": 1531,
	"./template.epicodds.tsx": 1531,
	"./template.fiestabet": 1532,
	"./template.fiestabet.tsx": 1532,
	"./template.forsport": 1533,
	"./template.forsport.tsx": 1533,
	"./template.gigabet": 1534,
	"./template.gigabet.tsx": 1534,
	"./template.goldenbet888": 2060,
	"./template.goldenbet888.tsx": 2060,
	"./template.goldenrush": 1535,
	"./template.goldenrush.tsx": 1535,
	"./template.hyperbet": 1536,
	"./template.hyperbet.tsx": 1536,
	"./template.juicybet": 1537,
	"./template.juicybet.tsx": 1537,
	"./template.junglebet": 1538,
	"./template.junglebet.tsx": 1538,
	"./template.magnumbet": 1539,
	"./template.magnumbet.tsx": 1539,
	"./template.oldgill": 1540,
	"./template.oldgill.tsx": 1540,
	"./template.puntcity": 1541,
	"./template.puntcity.tsx": 1541,
	"./template.puntgenie": 1542,
	"./template.puntgenie.tsx": 1542,
	"./template.pyramidbet": 1543,
	"./template.pyramidbet.tsx": 1543,
	"./template.questbet": 1544,
	"./template.questbet.tsx": 1544,
	"./template.slambet": 1545,
	"./template.slambet.tsx": 1545,
	"./template.sterlingparker": 1546,
	"./template.sterlingparker.tsx": 1546,
	"./template.sugarcastle": 1547,
	"./template.sugarcastle.tsx": 1547,
	"./template.templebet": 1548,
	"./template.templebet.tsx": 1548,
	"./template.titanbet": 1549,
	"./template.titanbet.tsx": 1549,
	"./template.ts": 975,
	"./template.vikingbet": 1550,
	"./template.vikingbet.tsx": 1550,
	"./template.volcanobet": 1551,
	"./template.volcanobet.tsx": 1551,
	"./template.wellbet": 1552,
	"./template.wellbet.tsx": 1552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2443;